import {
  collection,
  doc,
  setDoc,
  onSnapshot,
  serverTimestamp,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useRoutineStore } from '@/stores/routineStore';
import type { RoutineRun } from '@/types';
import { toDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function runsCol(uid: string) {
  return collection(db, 'users', uid, 'runs');
}

export function startRunSync(uid: string): Unsubscribe {
  return onSnapshot(
    runsCol(uid),
    (snap) => {
      const runs: RoutineRun[] = snap.docs.map((d) => {
        const data = d.data();
        const run: RoutineRun = {
          id: d.id,
          routineId: data.routineId as string,
          status: data.status as RoutineRun['status'],
          startedAt: toDate(data.startedAt),
          completedAt: toDate(data.completedAt),
          routineNameSnapshot: data.routineNameSnapshot as string,
          steps: (data.steps as RoutineRun['steps']) ?? [],
        };
        return run;
      });
      useRoutineStore.setState({ runs });
    },
    logSyncError('runSync', uid),
  );
}

export async function writeRun(uid: string, run: RoutineRun): Promise<void> {
  const { id, ...rest } = run;
  await setDoc(doc(runsCol(uid), id), { ...rest, serverUpdatedAt: serverTimestamp() });
}
